var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from './Icon';
export var ErrorIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { role: "button" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM19 11C19 10.4477 18.4777 10 17.8333 10H6.16667C5.52233 10 5 10.4477 5 11V13C5 13.5523 5.52233 14 6.16667 14H17.8333C18.4777 14 19 13.5523 19 13V11Z", fill: "#ED5A4F" }))); };
//# sourceMappingURL=ErrorIcon.js.map